exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".orgSearch{width:100%;text-align:center;margin-bottom:1.5em}.orgSearch .orgInputRowOne select{font-size:16px;display:inline-block;width:30%;margin-right:1rem}.orgSearch .orgInputRowOne input{font-size:16px;display:inline-block;width:20%;margin-right:1rem}.orgSearch .orgInputRowTwo{margin-top:10px}.orgSearch .orgInputRowTwo input{font-size:16px;display:inline-block;width:20%;margin-right:1rem}.orgSearch .orgFuzzySearch{margin-top:15px;text-align:left;max-width:800px;margin-left:auto;margin-right:auto}.orgSearch .orgFuzzySearch textarea{width:100%;font-size:14px;padding:10px;border:1px solid #ccc;border-radius:4px;font-family:inherit;resize:vertical}.orgSearch .orgFuzzySearch .fuzzySearchHelp{margin-top:8px;font-size:13px;color:#666;font-style:italic}.orgSearch .buttonPrimary{margin-top:-.3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/org_search.scss
// module id = 827
// module chunks = 0